import { render, staticRenderFns } from "./ResultSearch.vue?vue&type=template&id=6d8becaa&scoped=true&"
import script from "./ResultSearch.vue?vue&type=script&lang=js&"
export * from "./ResultSearch.vue?vue&type=script&lang=js&"
import style0 from "./ResultSearch.vue?vue&type=style&index=0&id=6d8becaa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8becaa",
  null
  
)

export default component.exports